import type { GradeItemType } from "@/lib/api/gradebook";

export type Draft = {
  version?: string;
  label: string;
  type: GradeItemType;
  weight: string;
  remove: boolean;
};

export const validWeight = (value: string) =>
  value.trim() !== "" &&
  Number.isInteger(Number(value)) &&
  Number(value) >= 0 &&
  Number(value) <= 100;
